import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type RootState, useAppSelector } from '#store/store.ts';

export interface UserProfile {
    sub?: string;
    azp?: string;
    account?: string;
    givenName?: string;
    familyName?: string;
    name?: string;
    locale?: string;
    email?: string;
    tenant?: string;
    phoneNumber?: string;
}

export interface LoginState {
    hasUserSessionEverExpired: boolean;
    userProfile: UserProfile | null;
    userSessionExpired: boolean;
}

const initialState: LoginState = {
    hasUserSessionEverExpired: false,
    userProfile: null,
    userSessionExpired: false,
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        userProfileObtained: (state, action: PayloadAction<UserProfile>) => {
            state.userProfile = action.payload;
        },
        userSessionExpired: state => {
            state.hasUserSessionEverExpired = true;
            state.userSessionExpired = true;
        },
        userSessionRenewed: state => {
            state.userSessionExpired = false;
        },
    },
});

export const { userProfileObtained, userSessionExpired, userSessionRenewed } = loginSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getUserProfile = (state: RootState) => state.login.userProfile;
export const getUserAccount = (state: RootState) => state.login.userProfile?.account;
export const getTenant = (state: RootState) => state.login.userProfile?.tenant;

export const useLoginInfo = () => {
    const userProfile = useAppSelector(getUserProfile);
    const isLoggedIn = !!userProfile;
    const accountId = userProfile?.account;
    return { isLoggedIn, accountId };
};
export const useGetTenant = () => useAppSelector(getTenant);
export default loginSlice.reducer;
